import React from 'react'
import { Swiper, SwiperSlide } from '@components/molecules/Slider'

interface LegendItem {
  image: string
  name: string
  role: string
  play: string
  accentColor: string
}

export interface SportsBeerCertifiedLegendsData {
  stampImage: string
  items: LegendItem[]
}

const SportsBeerCertifiedLegends: React.FC<SportsBeerCertifiedLegendsData> = ({
  stampImage,
  items,
}) => {
  if (!items?.length) return null

  return (
    <div className="w-full">
      <Swiper
        loop={true}
        centeredSlides={true}
        slidesPerView={1.3}
        grabCursor={true}
        spaceBetween={15}
        pagination={{ el: '.sports-beer-legends-pagination', clickable: true }}
        breakpoints={{
          769: { slidesPerView: 2.3, spaceBetween: 20 },
          1024: { slidesPerView: 3.2, spaceBetween: 32 },
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="bg-[#FAF4F4] p-3 pr-0 border-[3px] border-[#3E2F3D] relative shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] min-[769px]:p-4 min-[769px]:pr-0 min-[769px]:shadow-none">
              {/* Colored tab */}
              <div
                className="absolute top-0 right-5 w-[71px] h-[27px] border-l-[3px] border-r-[3px] border-b-[3px] border-[#3E2F3D] z-[4]"
                style={{ backgroundColor: item.accentColor }}
              />

              {/* Image */}
              <div className="w-full aspect-[289/337] relative border-2 border-gray-900 overflow-hidden">
                {item.image ? (
                  <img
                    src={item.image}
                    alt={item.name}
                    className="absolute inset-0 w-full h-full object-cover object-center border-[3px] border-[#3E2F3D] border-r-0"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-full h-full bg-gray-200" />
                )}
                {stampImage && (
                  <img
                    src={stampImage}
                    alt="stamp"
                    className="absolute top-[15px] right-2 w-[90px] h-auto border-0"
                    loading="lazy"
                  />
                )}
              </div>

              {/* Name — absolute overlay on card */}
              <h4 className="font-endless text-[42px] text-[#CBFF00] [text-shadow:3px_3px_0_#3E2F3D] [-webkit-text-stroke-width:1px] [-webkit-text-stroke-color:#3E2F3D] tracking-[0.42px] rotate-[-4.748deg] absolute bottom-[100px] leading-normal">
                {item.name}
              </h4>

              {/* Info bar */}
              <div
                className="grid gap-[4px] p-2 border-l-[3px] border-b-[3px] border-[#3E2F3D] text-left"
                style={{ backgroundColor: item.accentColor }}
              >
                <p className="font-bn-dime text-[21px] text-[#3E2F3D] leading-normal">{item.role}</p>
                <p className="font-bookman text-[13px] text-[#3E2F3D] text-left leading-normal">
                  Favorite Play: &quot;{item.play}&quot;
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="sports-beer-legends-pagination max-[480px]:hidden" />
    </div>
  )
}

export default SportsBeerCertifiedLegends
